import http from "@/http"

export const getValidAttachmentTypes = async function () {
  const { data } = await http.get("attachments/valid-types")
  return new Set(data as string)
}